module.exports = __webpack_public_path__ + "img/award-bg2.8efdac12.png";